import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { NavigationService } from '@core/navigation/services/navigation.service';
import { BackendAvailabilityService } from '@core/pages/error-pages/backend-unavailable/services/backend-availability.service';
import { AppPathsMap } from '@core/routing/app-paths';

export const backendUnavailableGuard: CanActivateFn = (route, state) => {
  const navigationService = inject(NavigationService);
  const backendAvailabilityService = inject(BackendAvailabilityService);

  if (!backendAvailabilityService.isBackendUnavailable()) {
    if (state.url === `/${AppPathsMap.Error.BackendUnavailable}`) {
      return navigationService.createUrlTree([AppPathsMap.Homepage]);
    }
    return true;
  }

  return true;
};
